import { render, staticRenderFns } from "./AttributeViewComponent.vue?vue&type=template&id=4daf624a"
import script from "./AttributeViewComponent.vue?vue&type=script&lang=js"
export * from "./AttributeViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports